import React from 'react'
// import {Button} from '@mui/material';
import CardEvent from '../Cards/CardEvent'
// import CardCareer from "../../Component/Cards/CardCareer";
// import Services_Carosel from "../../Component/Carosel/Services_Carosel";
// import { Link } from "react-router-dom";

const Events = (Props) => {
  const get_Data = Props.Event_DATA

  return (
    <section className="container my-5">
      <h2 className="text-center mb-5">{Props.title}</h2>
      <CardEvent getdata={get_Data}></CardEvent>
      {/* <CardCareer getdata={PBData}></CardCareer> */}
      {/* <Services_Carosel/> */}
    </section>
  )
}

export default Events
